<template>
  <div>
    <h3 v-if="creerLe">
      <p>Créé le : {{ $commun.formatDateHeure(creerLe) }} Par :
        {{ creerPar }} </p>
      <p>Modifié le : {{ $commun.formatDateHeure(creerLe) }} Par :
        {{ creerPar }} </p>
    </h3>
  </div>
  <DataTable :value="auditsDataAfficher" rowGroupMode="subheader" sortMode="single"
             resizableColumns columnResizeMode="expand"
             scrollable scrollHeight="890px" tableStyle="min-width: 50rem">
    <Column field="abreviation" header="Abréviation" style="min-width: 350px">
      <template #body="slotProps">
        {{
          slotProps.data.abreviation
        }}
      </template>
    </Column>
    <Column field="description" header="Description" style="min-width: 200px">
      <template #body="slotProps">
        {{
          slotProps.data.description
        }}
      </template>
    </Column>
    <Column field="aide" header="Aide en ligne" style="min-width: 200px">
      <template #body="slotProps">
        {{
          slotProps.data.aide
        }}
      </template>
    </Column>
    <Column field="action" header="Changements" style="min-width: 1000px">
      <template #body="slotProps">
        {{ formatAction(slotProps.data.action) }}
        {{ $commun.formatDateHeure(slotProps.data.modifierLe) }}
        Par :
        {{ slotProps.data.modifierParAffichage }}

        <div v-if="slotProps.data.justificationFichier.length > 0">
          <DataTable
              class="p-datatable-sm"
              :value="slotProps.data.justificationFichier"
              :resizableColumns="true"
              columnResizeMode="fit"
              :reorderableColumns="true"
              sortField="cle"
              :sortOrder="-1"
              responsiveLayout="scroll"
              :scrollableY="true"
              scrollHeight="500px"
              dataKey="cle"
          >
            <Column
                field="description"
                header="Description"
                :sortable="true"
                class="table-txt-wrap"
                @click="onSelect"
            >
              <template #body="slotProps">
                <label class="hyperlink underline"
                       @click="onSelect(slotProps.data)">{{ slotProps.data.description }}</label>
              </template>
            </Column>
            <Column
                field="creerPar"
                header="Créé Par"
                :sortable="true"
                class="table-txt-wrap"
            ></Column>
            <Column
                field="creerLe"
                header="Date de création"
                :sortable="true"
                class="table-txt-wrap"
            >
              <template #body="slotProps">
                {{
                  $commun.formatDateHeure(
                      slotProps.data.creerLe
                  )
                }}
              </template>
            </Column>
          </DataTable>
        </div>
      </template>

    </Column>
  </DataTable>
  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "TableValeurTableModifications",
  emits: ["isDataLoaded", "backendError"],
  beforeMount() {
    this.$root.$refs.breadcrumbComp.activeBallBeat = true;
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch("pilotage/obtenirAuditTableValeurAction", {
          cle: this.$route.params.cle
        })
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            this.auditsDataAfficher = res.data.sort((a, b) => {
              return new Date(a.modifierLe) - new Date(b.modifierLe)
            });
          } else {
            this.auditsDataAfficher = this.formatterAucunAudit();
          }
          this.$root.$refs.breadcrumbComp.activeBallBeat = false;
        })
        .catch((err) => {
          this.$emit("backendError", err);
        })
        .finally(() => {
          this.$emit("isDataLoaded", true);
        })
  },
  data() {
    return {
      auditsDataAfficher: [],
      justificationFichier: {},
      AUDIT_FIELDS: [
        "modifierLe",
        "justificationTexte",
        "modifierParComplet",
        "abreviation",
        "description",
        "aide",
        "justificationFichier"
      ],
      FIELD_LABELS: {
        "modifierLe": "Enregistrement en date du ",
        "justificationTexte": "Justification ",
        "modifierParComplet": "Par ",
        "abreviation": "Abréviation ",
        "description": "Description ",
        "aide": "Aide ",
        "justificationFichier": "Fichier(s) de justification"
      },
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
    nombreModifications() {
      return this.auditsDataAfficher.length;
    },
    tailleListeMultimedia() {
      return this.justificationFichier.length
    },
    listeMultimedia() {
      return this.justificationFichier
    },
    creerLe() {
      if (this.auditsDataAfficher.length > 0 ) {
        return this.auditsDataAfficher[0].modifierLe
      }
      return null
    },
    creerPar() {
      return this.auditsDataAfficher[0].modifierParAffichage
    },
  },
  methods: {
    formatAction(action){
      if (action == 0) {
        return "Retiré le :"
      }else {
        return "Modifier le :"
      }
    },
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "modifierLe": "",
        "justificationTexte": "",
        "modifierParComplet": "",
        "abreviation": "",
        "description": "",
        "aide": "",
        "justificationFichier": "",
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = {texte: audit[field], isModifie: false,}
      })

      listeAudits.push(auditAffichage);
      return listeAudits;
    },
    onSelect(event){
      var arr = event.donnees;
      const linkSource = `data:application/pdf;base64,${arr}`;
      const downloadLink = document.createElement("a");
      const fileName = event.description;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  },
};
</script>
